import { environmentHttpClient } from "client/Api/httpClient";

export enum ExchangeServerInstanceType {
	Office365 = 0,
	OnPremises = 1
}

export type EnvironmentExchangeSettingsViewModel = {
	isEnabled: boolean;
	areNewEmailActivitiesEnabled: boolean | null;
};

export type EnvironmentExchangeSettingsSavingModel = {
	areNewEmailActivitiesEnabled: boolean;
};

export function getPageViewModel(signal?: AbortSignal): Promise<EnvironmentExchangeSettingsViewModel> {
	return environmentHttpClient.get<EnvironmentExchangeSettingsViewModel>(
		"/UiApi/EnvironmentExchangeSettings",
		undefined,
		{ signal }
	);
}

export function disable(signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/EnvironmentExchangeSettings/Disable",
		{},
		{ signal }
	);
}

export function enableAndSave(
	model: EnvironmentExchangeSettingsSavingModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/EnvironmentExchangeSettings/EnableAndSave",
		model,
		{ signal }
	);
}